export default '@@RESIFT/ERROR';
